import { ProductionContract } from '@work4all/models/lib/Classes/ProductionContract.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/productionContract-table-schema.json';

const defaultSort = [
  { field: 'creationDate', direction: SortDirection.DESCENDING },
];

const secondarySort = [
  { field: 'number', direction: SortDirection.DESCENDING },
];

export function ProductionContractsTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<ProductionContract, never>({
    ...props,
    schema: schema as never,
    defaultSort,
    secondarySort,
  });

  return <EntityTableV8 {...props} {...dataTable} />;
}
